import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import Login from 'components/Login'
import Index from 'components/Index'
// import Events from 'components/Events/Index'
// import EventsEditor from 'components/Events/Editor'

import IndexPage from './IndexPageRoutes'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      children: IndexPage.children
    }, {
      path: '/login',
      name: 'Login',
      component: Login
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (!store.state.user && to.name !== 'Login') {
    store.dispatch('getAccount')
      .then(() => {
        if (store.state.user.id) {
          next('/main')
        }
      })
      .catch(_ => {
        next('/login')
      })
  } else if (to.name !== 'Login') {
    const role = store.state.user.role
    const menu = Array.concat(...Object.values(store.state.menu))
    const route = menu.find(i => i.name === to.name)
    if (!(route && route.roles.includes(role))) {
      const availableRoute = menu.find(i => i.roles.includes(role)) || { name: 'Login' }
      return router.push({ name: availableRoute.name })
    }
    next()
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js